export class CommunityLotModel {
    ContractID: number;
    CommunityLotID: number;
    LotNo: string;
    CommunityID: number;
    CommunityName: string;
    IsDesignFeatureEnabled: boolean;
    IsClosed: boolean;
    Address: string;
    latitude: string;
    longitude: string;
    placeId: string;
    IsWarrantyenable: boolean;
    WarrantyExiprydate:Date;
    IsCobuyer : boolean;
    LotNoWithAddress : string
}


// WEBPACK FOOTER //
// ./src/app/models/CommunitylotModel.ts